import React from 'react';

import PaperAirplane from './PaperAirplane';

const PaperAirplaneRight = props => (
  <PaperAirplane style={{ transform: 'rotate(90deg)' }} {...props} />
);

export default PaperAirplaneRight;
